import Details from './Details'

export * from './Details'
export default Details
